import Vue from "vue";
import VueRouter from "vue-router";
import Meta from 'vue-meta'

Vue.use(VueRouter);
Vue.use(Meta);

const Home = () => import("@/views/Home.vue");
const About = () => import("@/views/About.vue");
const Contact = () => import("@/views/Contact.vue");
const Team = () => import("@/views/Team.vue");
const FAQ = () => import("@/views/FAQ.vue");
const Seminar = () => import("@/views/seminarInfo/Seminar.vue");
const SeminarInfo = () => import("@/views/seminarInfo/SeminarInfo.vue");
const Timeline = () => import("@/views/seminarInfo/AZTimeline.vue");
const GenInfo = () => import("@/views/seminarInfo/GeneralInfo.vue");
const Bewerbung = () => import("@/views/seminarInfo/Bewerbung.vue");
const Impressionen = () => import("@/views/Impressionen.vue");
const Projekte = () => import("@/views/Projekte.vue");
const Legal = () => import("@/views/legal/Legal.vue");

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home
    },
    {
        path: "/about",
        name: "About",
        component: About
    },
    {
        path: "/contact",
        name: "Contact",
        component: Contact
    },
    {
        path: "/team",
        name: "Team",
        component: Team
    },
    {
        path: "/faqs",
        name: "FAQs",
        component: FAQ
    },
    {
        path: "/seminar",
        component: GenInfo,
        children: [
            {
                path: "info",
                component: SeminarInfo
            },
            {
                path: "phasen",
                component: Seminar
            },
            {
                path: "timeline",
                component: Timeline
            },
            {
                path: "bewerbung",
                component: Bewerbung
            },
            {
                path: "",
                component: SeminarInfo
            }
        ]
    },
    {
        path: "/projekte",
        component: Projekte
    },
    {
        path: "/legal/:mode",
        component: Legal,
        props: true
    },
    {
        path: "/impressionen/:year?",
        component: Impressionen,
        props: true
    }

];

const router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    routes
});

export default router;
